<div *ngIf="widgetLayers">
  <app-widget-date-bounds *ngFor="let bounds of widgetLayers.bounds | keyvalue" [bounds]="bounds.value"></app-widget-date-bounds>
</div>